import React from "react";
import NoFooterModal from "../../Common/NoFooterModal";
import {
  BottomSectionModal,
  FlexContainer,
} from "../../../constants/assets/containers";
import Permission from "../../Common/Permission";
import Input from "sushiweb/InputTypes/Input";
import MenuActionsMappings from "../../../constants/Menu/MenuActionsMappings";
import MenuNames from "../../../constants/Menu/MenuNames.json";
import Button from "sushiweb/Button";
import { isValidated, isValNull } from "../../../utils";
import InfiniteScrollDropdown from "../../Common/InfiniteScrollDropdown";
import PaginatedReactDropdown from "../../Common/PaginatedReactDropdown";
import { bindActionCreators } from "redux";
import * as SubIssueTypeActions from "../../../store/actions/SubIssueTypes";
import { connect } from "react-redux";
import * as CallDepartmentsAction from "../../../store/actions/CallDepartments";
import * as UserActions from "../../../store/actions/User";
import { getIssueTypeRemoteSearch } from "../../../store/actions/SubIssueTypes";
import { getCity, getCityList } from "../../../store/actions/City";
import Capitalize from "lodash-es/capitalize";

const enableOptions = [
  { key: true, label: "True" },
  { key: false, label: "False" },
];
const fulfillmentTypeOptions = [
  { key: "NORMAL", label: "NORMAL" },
  { key: null, label: "DEFAULT" },
  { key: "INTERCITY", label: "INTERCITY" },
  { key: "INTRACITY", label: "INTRACITY" },
  { key: "A2A", label: "A2A" },
  { key: "TRAIN", label: "TRAIN" },
  { key: "PARTY", label: "PARTY" },
  { key: "CINEMA", label: "CINEMA" },
];
const mandatoryFieldsToCheck = ["departmentName", "rank"];
const orderCategoryOptions = ["FOOD", "INSTANT_FOOD", "BLINKIT", "B2B", "EXPRESS", "HYPERPURE"];

const CallDepartmentModal = (props) => {
  const allActions =
    MenuActionsMappings[MenuNames.LOGISTICS_SUPPORT_DEPARTMENTS];
  const {
    activeId,
    modalState,
    handleClose,
    remoteSearch,
    getIssueTypeRemoteSearch,
    activeObject,
    getCallDepartmentList,
    setStatus,
    upsertCallDepartments,
    currentPage,
    getCallDepartmentsDetails,
    activeFilters,
    languageRemoteSearch,
    getCallDepartmentLanguageRemoteSearch,
    getCityList,
    nextPageCity,
  } = props;
  const [priorityFlag, setPriorityFlag] = React.useState(true);
  const [initialState, setInitialState] = React.useState({
    cityName: null,
    language: null,
    issueTypeName: null,
    premiumDp: null,
    premiumCustomer: null,
    orderCategory: null,
    breachedOrder: null,
    departmentName: "",
    enabled: null,
    id: null,
    rank: null,
    newRider: null,
    orderValue: null,
    fulfillmentType: null,
    fraudDetected: null,
  });
  React.useEffect(() => {
    if (activeFilters && modalState === "Filter") {
      setInitialStateObjectValues(activeFilters);
    }
  }, [activeFilters]);
  React.useEffect(() => {
    if (activeObject && modalState === "Edit") {
      setInitialStateObjectValues(activeObject);
    }
  }, [activeObject]);

  React.useEffect(() => {
    if (activeId) {
      getCallDepartmentsDetails(activeId);
    }
  }, [activeId, modalState]);

  const setInitialStateObjectValues = (obj) => {
    setPriorityFlag(false);
    if (Object.keys(obj).length > 0) {
      let values = { ...initialState };
      Object.keys(values).map((item, index) => {
        if (!isValNull(obj[item])) {
          values[item] = obj[item];
        }
      });
      setInitialState(values);
    }
    setPriorityFlag(true);
  };

  const handleClearFilters = () => {
    getCallDepartmentList(1, {}).then((res) => {
      handleClose();
    });
  };
  const getRequiredButtonPerms = (action = undefined) => {
    if (modalState === "Edit" || modalState === "Add") {
      return [allActions.UPDATE];
    }
    return undefined;
  };
  const handleSubmit = () => {
    if (modalState === "Filter") {
      getCallDepartmentList(1, initialState).then((res) => {
        handleClose();
      });
    } else {
      let validatedState = isValidated(initialState, mandatoryFieldsToCheck);
      if (validatedState !== "validated") {
        setStatus({ type: "error", message: Capitalize(validatedState) });
        return;
      }
      // mapping false value to null values
      if (initialState["rank"]) {
        initialState["rank"] = Number(initialState["rank"]);
      }
      if (initialState["orderValue"]) {
        initialState["orderValue"] = parseFloat(initialState["orderValue"]);
      }
      initialState["supportType"] = "callback"; // @todo: create a dropdown for selecting call dept or chat dept
      Object.keys(initialState).map((key) => {
        if (
          key === "premiumDp" ||
          key === "premiumCustomer" ||
          key === "breachedOrder" ||
          key === "enabled"
        ) {
          initialState[key] = initialState[key] ? initialState[key] : false;
        }
      });
      upsertCallDepartments(initialState).then((res) => {
        getCallDepartmentList(currentPage, activeFilters);
        handleClose();
      });
    }
  };
  const handleChange = (key, value) => {
    setInitialState((prevState) => {
      return { ...prevState, [key]: value };
    });
  };

  const getModalButtons = () => {
    return (
      <BottomSectionModal className="flex items-center justify-between">
        {modalState === "Filter" ? (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClearFilters}
            className="sushi-btn"
          >
            Clear
          </Button>
        ) : (
          <Button
            data-testid="filterFeatureBtn"
            onClick={handleClose}
            className="sushi-btn"
          >
            Cancel
          </Button>
        )}
        <Permission requiredPerms={getRequiredButtonPerms()}>
          <Button
            data-testid="submitCallDeptButton"
            className="sushi-btn"
            onClick={handleSubmit}
          >
            {modalState === "Filter" ? "Apply" : "Submit"}
          </Button>
        </Permission>
      </BottomSectionModal>
    );
  };
  const getLanguageActiveItemById = async (id) => {
    for (let i = 0; i < languageRemoteSearch.languages.length; i++) {
      if (id === languageRemoteSearch.languages[i].name) {
        return languageRemoteSearch.languages[i];
      }
    }
    return {};
  };
  const getIssueTypeActiveItemById = async (id) => {
    for (let i = 0; i < remoteSearch.issueTypeList.length; i++) {
      if (id === remoteSearch.issueTypeList[i].issue) {
        return remoteSearch.issueTypeList[i];
      }
    }
    return {};
  };
  const getInputLabel = (val, options, fromKey, toKey, isNumber) => {
    const activeEle = options.find((item) => {
      return item[fromKey] === (isNumber ? parseInt(val) : val);
    });
    return !isValNull(activeEle) ? activeEle[toKey] : "";
  };
  const getPriorityFlagVal = () => {
    if (
      modalState === "Edit" &&
      Object.keys(activeObject).length > 0 &&
      !isValNull(activeObject["cityName"])
    ) {
      return false;
    } else if (
      modalState === "Filter" &&
      Object.keys(activeFilters).length > 0 &&
      !isValNull(activeFilters["cityName"])
    ) {
      return false;
    }
    return true;
  };
  return (
    <NoFooterModal
      header={true}
      heading={`${modalState} Call Department`}
      handleClose={handleClose}
      id="CallDeptFormModal"
      modalButtons={getModalButtons()}
    >
      <Input
        value={initialState.departmentName}
        data-testid="departmentName"
        id="sushi-input"
        onChange={(e) => handleChange("departmentName", e)}
        label="Department name"
      />
      <PaginatedReactDropdown
        options={orderCategoryOptions}
        data-testid="callDeptOrderCategory"
        value={initialState.orderCategory}
        labelWidth="20%"
        handleChange={handleChange}
        keyToChange="orderCategory"
        placeholder="Order Category"
        showCross={true}
        id="callDeptOrderCategory"
      />
      <InfiniteScrollDropdown
        id="cityNameCallDept"
        appliedFilters={{}}
        priorityFlag={getPriorityFlagVal()}
        getActiveList={getCityList}
        nextPage={nextPageCity}
        defaultVal={
          initialState.cityName ? { city_name: initialState.cityName } : ""
        }
        showDefaultVal={true}
        value={null}
        resKey="cities"
        modalState={modalState}
        keyName="cityName"
        labelKey="city_name"
        getDataLabelKey="city.city_name"
        keyTypeToSet="city_name"
        label="City"
        handleChange={handleChange}
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
        activeFilters={activeFilters}
        activeElement={activeObject}
        getActiveItemById={getCity}
      />
      <InfiniteScrollDropdown
        id="issueTypeCallDepartments"
        priorityFlag={true}
        getActiveList={getIssueTypeRemoteSearch}
        nextPage={remoteSearch.nextPage}
        resKey="data" // key to get the list
        keyName="issueTypeName"
        modalState={"Edit"}
        labelKey="issue" // key for label
        getDataLabelKey="issue"
        keyTypeToSet="issue" // key to return the data of
        label="Issue Type"
        handleChange={handleChange}
        activeElement={initialState}
        getActiveItemById={getIssueTypeActiveItemById}
        appliedFilters={{}}
        width="50%"
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
      />
      <InfiniteScrollDropdown
        id="languageInfiniteDropDown"
        setPriorityFlag={setPriorityFlag}
        priorityFlag={priorityFlag}
        getActiveList={getCallDepartmentLanguageRemoteSearch}
        nextPage={languageRemoteSearch.nextPage}
        resKey="data" // key to get the list
        keyName="language"
        modalState={"Edit"}
        labelKey="name" // key for label
        getDataLabelKey="name"
        keyTypeToSet="name" // key to return the data of
        label="Language"
        handleChange={handleChange}
        activeElement={initialState}
        activeFilters={activeFilters}
        getActiveItemById={getLanguageActiveItemById}
        appliedFilters={{}}
        width="50%"
        remoteSearchApplicable={true}
        remoteSearchKey="startswith"
      />
      {modalState !== "Filter" ? (
        <Input
          value={initialState.rank}
          data-testid="departmentRank"
          id="sushi-input"
          onChange={(e) => handleChange("rank", e)}
          label="Rank"
          type={"number"}
        />
      ) : null}
      {modalState !== "Filter" ? (
        <Input
          value={initialState.orderValue}
          id="sushi-input"
          onChange={(e) => handleChange("orderValue", e)}
          label="Order Value (Optional)"
          type={"number"}
        />
      ) : null}
      <FlexContainer justify="flex-start">
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="callDeptPremiumDp"
          value={getInputLabel(
            initialState.premiumDp,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="30%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="premiumDp"
          placeholder="Premium DP"
          showCross={true}
          id="chatDeptEnabled"
        />
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="callDeptpremiumCustomer"
          value={getInputLabel(
            initialState.premiumCustomer,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="42%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="premiumCustomer"
          placeholder="Premium Customer"
          showCross={true}
          id="chatDeptPriority"
        />
      </FlexContainer>
      <FlexContainer justify="flex-start">
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="callDeptBreachedOrder"
          value={getInputLabel(
            initialState.breachedOrder,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="35%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="breachedOrder"
          placeholder="Breached Order"
          showCross={true}
          id="chatDeptPriority"
        />
        <PaginatedReactDropdown
          options={enableOptions}
          data-testid="callDeptEnabled"
          value={getInputLabel(
            initialState.enabled,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="20%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="enabled"
          placeholder="Enabled"
          showCross={true}
          id="chatDeptEnabled"
        />
      </FlexContainer>
      <FlexContainer justify="flex-start">
        <PaginatedReactDropdown
          options={enableOptions}
          value={getInputLabel(
            initialState.newRider,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="100%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="newRider"
          placeholder="New Rider (Optional)"
          showCross={true}
          id="chatDeptNewRider"
        />
        <PaginatedReactDropdown
          options={fulfillmentTypeOptions}
          value={getInputLabel(
            initialState.fulfillmentType,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="100%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="fulfillmentType"
          placeholder="Fulfillment Type (Optional)"
          showCross={true}
          id="callDeptfulfillmentType"
        />
      </FlexContainer>
      <FlexContainer justify="flex-start">
        <PaginatedReactDropdown
          options={enableOptions}
          value={getInputLabel(
            initialState.fraudDetected,
            enableOptions,
            "key",
            "label"
          )}
          labelWidth="100%"
          labelKey="label"
          valueKey="key"
          handleChange={handleChange}
          keyToChange="fraudDetected"
          placeholder="Fraud Detected (Optional)"
          showCross={true}
          id="callDeptFraudDetected"
        />
      </FlexContainer>
    </NoFooterModal>
  );
};

const mapStateToProps = (state) => {
  const { City, IssueTypes, CallDepartments } = state;
  return {
    activeObject: CallDepartments.activeObject,
    activeFilters: CallDepartments.activeFilters,
    currentPage: CallDepartments.currentPage,
    languageRemoteSearch: CallDepartments.languageRemoteSearch,
    nextPageIssueTypes: IssueTypes.nextPage,
    remoteSearch: IssueTypes.remoteSearch,
    cityList: City.cityList,
    nextPageCity: City.nextPage,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    getSubIssueTypeRemoteSearch: bindActionCreators(
      SubIssueTypeActions.getSubIssueTypeRemoteSearch,
      dispatch
    ),
    getCallDepartmentList: bindActionCreators(
      CallDepartmentsAction.getCallDepartmentList,
      dispatch
    ),
    upsertCallDepartments: bindActionCreators(
      CallDepartmentsAction.upsertCallDepartments,
      dispatch
    ),
    setStatus: bindActionCreators(UserActions.setStatus, dispatch),
    getCallDepartmentsDetails: bindActionCreators(
      CallDepartmentsAction.getCallDepartmentsDetails,
      dispatch
    ),
    getCallDepartmentLanguageRemoteSearch: bindActionCreators(
      CallDepartmentsAction.getCallDepartmentLanguageRemoteSearch,
      dispatch
    ),
    getIssueTypeRemoteSearch: bindActionCreators(
      getIssueTypeRemoteSearch,
      dispatch
    ),
    getCity: bindActionCreators(getCity, dispatch),
    getCityList: bindActionCreators(getCityList, dispatch),
  };
};
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CallDepartmentModal);
